import { useEffect, useState } from 'react';

import type { SimilarPropertiesFragment } from '__generated__/athena/graphql';
import { GetMarketplacePropertySimilarPropertiesDocument } from '__generated__/athena/graphql';
import { getAthenaClient } from 'components/api';

export const useSimilarProperties = (addressToken?: string) => {
  const [similarProperties, setSimilarProperties] = useState<
    SimilarPropertiesFragment | null | undefined
  >();

  useEffect(() => {
    if (!addressToken) {
      return;
    }
    getAthenaClient()
      .request(GetMarketplacePropertySimilarPropertiesDocument, { addressToken })
      .then((data) => {
        setSimilarProperties(data?.marketplace?.property?.similarProperties);
      });
  }, [addressToken]);

  return { similarProperties };
};
